import { useEffect, useState } from 'react';
import { Icon } from '../Icon/Icon';
import { FavoriteStorage } from '../Util/FavoriteStorage';

export interface IFavoriteTogglerProps {
    currentItemId: string;
    storageKey: string;
    onFavoriteChange?: (isFavorite: boolean) => void;
}

export const FavoriteToggler: React.FC<IFavoriteTogglerProps> = ({ currentItemId, storageKey, onFavoriteChange }) => {
    const [isFavorite, setIsFavorite] = useState(false);
    const favoriteStorage = new FavoriteStorage(storageKey);

    useEffect(() => {
        const isFavorite = favoriteStorage.isFavorite(currentItemId);
        setIsFavorite(isFavorite);
    }, [currentItemId, favoriteStorage]);

    const addAsFavorite = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        e.preventDefault();
        toggleFavorite(true);
    };

    const removeAsFavorite = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        e.preventDefault();
        toggleFavorite(false);
    };

    const toggleFavorite = (isFavorite: boolean) => {
        setIsFavorite(isFavorite);
        if (isFavorite) {
            favoriteStorage.addToStorage(currentItemId);
        } else {
            favoriteStorage.removeFromStorage(currentItemId);
        }
        if (onFavoriteChange) {
            onFavoriteChange(isFavorite);
        }
    };

    let title = 'Lägg till favorit';
    let onclick = addAsFavorite;
    let svgRef = 'star-vit';

    if (isFavorite) {
        title = 'Ta bort favorit';
        svgRef = 'star-gul';
        onclick = removeAsFavorite;
    }

    return (
        <a href="#" className="d-flex align-items-center favorite-toggler" onClick={onclick}>
            <span>{isFavorite ? 'Ta bort favorit' : 'Lägg till favorit'}</span>
            <div title={title} className="icon-favorite-star">
                <Icon symbol={svgRef} />
            </div>
        </a>
    );
};
